import PlantMilkProduct from 'models/PlantMilkProduct'

export const packagingInitialState = {
  category: PlantMilkProduct.category,
  subCategory: PlantMilkProduct.subCategory,
  MilkType: {
    value: PlantMilkProduct.MilkType,
    label: 'Plant-Based Milk Alternative Type',
  },
  OtherMilkType: PlantMilkProduct.OtherMilkType,
  Flavor: {
    value: PlantMilkProduct.Flavor,
    label: 'Flavor',
  },
  Type: {
    value: PlantMilkProduct.Type,
    label: 'Type',
  },
  Size: PlantMilkProduct.Size,
  Organic: PlantMilkProduct.Organic,
  MultiPackageType: PlantMilkProduct.MultiPackageType,
  MultiPackageCount: PlantMilkProduct.MultiPackageCount,
}

export const milkTypeOptions = [
  {
    value: '',
    label: 'Plant-Based Milk Alternative Type',
    isDisabled: true,
  },
  {
    value: 'Almond Milk',
    label: 'Almond Milk',
    category: '55',
    subCategory: '003',
    isBroadband: true,
  },
  {
    value: 'Cashew Milk',
    label: 'Cashew Milk',
    category: '55',
    subCategory: '003',
    isBroadband: true,
  },
  {
    value: 'Coconut Milk',
    label: 'Coconut Milk',
    category: '55',
    subCategory: '005',
    isBroadband: true,
  },
  {
    value: 'Oat Milk',
    label: 'Oat Milk',
    category: '55',
    subCategory: '002',
    isBroadband: true,
  },
  {
    value: 'Oat Milk Blend',
    label: 'Oat Milk Blend',
    category: '55',
    subCategory: '008',
    isBroadband: true,
  },
  {
    value: 'Pea Milk',
    label: 'Pea Milk',
    category: '55',
    subCategory: '007',
    isBroadband: true,
  },
  {
    value: 'Rice Milk',
    label: 'Rice Milk',
    category: '55',
    subCategory: '006',
    isBroadband: true,
  },
  {
    value: 'Seed Milk',
    label: 'Seed Milk',
    category: '55',
    subCategory: '004',
    isBroadband: true,
  },
  {
    value: 'Soy Milk',
    label: 'Soy Milk',
    category: '55',
    subCategory: '001',
    isBroadband: true,
  },
]
export const flavorOptions = [
  {
    value: '',
    label: 'Flavor',
    isDisabled: true,
  },
  {
    value: 'Original',
    label: 'Original',
  },
  { value: 'Plain', label: 'Plain' },
  { value: 'Regular', label: 'Regular' },
  { value: 'Vanilla', label: 'Vanilla' },
]

export const typeOptions = [
  {
    value: '',
    label: 'Type',
    isDisabled: true,
  },
  {
    value: 'Refrigerated',
    label: 'Refrigerated',
  },
  {
    value: 'Shelf-Stable',
    label: 'Shelf-Stable',
  },
]
